import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { SettingsPageLayout } from 'components/settings-page-layout/settings-page-layout.component';
import { NotificationSettingsCard } from './notification-settings.component';

export const NotificationsPage = () => {
  const { formatMessage } = useIntl();
  usePageViewAnalytics({ screen_name: 'Notifications' });
  useDocumentTitle(formatMessage({ id: 'STR_NOTIFICATIONS' }));

  return (
    <SettingsPageLayout heading={formatMessage({ id: 'STR_NOTIFICATIONS' })}>
      <NotificationSettingsCard />
    </SettingsPageLayout>
  );
};
